import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import formatDate, { getDayName } from "helpers/format-date";
import { billingToDeliveryDate } from "utils/subscription-date";
import Loader from "components/loader";
import useToggle from "hooks/useToggle";
import clsx from "clsx/lite";

export const ModalLayout = ({
	title, description, children, bodyClassName,
	confirmationButton, cancellationButton, showLoader = false, isConfirmDisabled = false,
	onConfirm = async () => { }, onCancel = () => { }
}) => {
	const [isLoading, toggleLoading] = useToggle();

	const toggle = useCallback(() => showLoader && toggleLoading(), []);

	const confirmAction = async () => {
		toggle();
		await onConfirm();
		toggle();
	};

	return (
		<>
			<div className="text-center w-11/12 mx-auto lg:mt-2">
				{title && <h3>{title}</h3>}
				{description && <p className="text-secondary my-2">{description}</p>}
			</div>
			<div className={clsx("flex flex-col justify-center items-center h-92 md:h-86 px-1.5 xs:px-5", bodyClassName)}>
				{children}
				{(confirmationButton || cancellationButton) &&
					<div className="flex flex-col gap-4 justify-center items-center mt-5 w-full">
						{confirmationButton && <button disabled={isConfirmDisabled} className="btn-primary w-full md:w-11/12 px-3" onClick={confirmAction}>
							{isLoading ? <Loader className="!size-5" ring={true} /> : confirmationButton}
						</button>}
						{cancellationButton && <button className="underline underline-offset-4" onClick={onCancel}>
							{cancellationButton}
						</button>}
					</div>}
			</div>
		</>
	);
};

export const NextDeliveryInfo = ({ increasedFontSize = false }) => {
	const { nextBillingDate, totalWeight, chargeOffsetDays } = useSelector((state) => state.account.subscription);
	const nextDeliveryDate = billingToDeliveryDate(nextBillingDate, chargeOffsetDays);
	const { language, translation } = useGlobalContext();

	return (
		<div>
			<h4 className={clsx("text-green-discount", increasedFontSize && "text-h3")}>{translation.subscription.next_delivery}</h4>
			<h4 className={clsx(increasedFontSize && "text-h3")}>
				{getDayName(nextDeliveryDate, language)},{" "}
				{formatDate(nextDeliveryDate, language, { month: "short", day: "numeric" })}
			</h4>
			<p className={clsx("text-secondary", increasedFontSize && "text-h4")}>{totalWeight} {translation.cart?.products}</p>
		</div>
	);
};